import { FC } from "react";
import { KTSVG } from "../../../_metronic/helpers";

type Props = {
    verdict: string | null
    setVerdict: Function
    setFieldValue: Function
    setStatus: Function
    hasRequest?: boolean
}

const VerdictSelector: FC<Props> = ({verdict, setVerdict, setFieldValue, setStatus, hasRequest}) => {
    return (
    <>
    <div className="text-muted w-normal fs-6 mb-2">Select verdict:</div>
    <div className='fv-row mb-2 d-flex flex-row gap-4'>
        <div
            className='flex-root' onClick={() => {
                setVerdict('approved');
                setFieldValue('verdict', 'approved');
                setStatus('');
            }}
        >
            <input
                id='kt_submit_review_type_approved'
                type='radio'
                className='btn-check'
                name="verdict"
                value='approved'

            />
            <label
                className={'btn py-2 px-6 d-flex flex-row align-items-center mb-2 ' + (verdict === 'approved' ? 'btn-success text-white' : ' btn-outline btn-outline-dashed btn-outline-default')}
                htmlFor='kt_submit_review_type_approved'
            >
                <KTSVG
                    path='/media/icons/duotune/abstract/abs009.svg'
                    className='svg-icon-2x me-5'
                />

                <div className='flex-grow-1 fw-bold text-center pe-10'>
                    <span className='fw-bolder d-block fs-4'>APPROVE</span>
                </div>
            </label>
        </div>
        { (hasRequest) && 
         <div className='flex-root' 
            onClick={() => { 
                setVerdict('request');
                setFieldValue('verdict', 'request');
                setStatus('');
            }}
        >
            <input
                id='kt_submit_review_type_request'
                type='radio'
                className='btn-check'
                name="verdict"
                value="request"
            />
            <label
                className={'btn py-2 px-6 d-flex flex-row align-items-center mb-2 ' + (verdict === 'request' ? 'btn-info text-white' : ' btn-outline btn-outline-dashed btn-outline-default')}
                htmlFor='kt_submit_review_type_request'
                title="Request for Information (Applicant)"
            >
                <KTSVG
                    path='/media/icons/duotune/general/gen045.svg'  
                    className='svg-icon-2x me-5'
                />

                <div className='min-w-100px fw-bold text-center'>
                    <span className='fw-bolder d-block fs-5'>RFI (APPLICANT)</span>
                </div>
            </label>
        </div>
        }
        <div className='flex-root'
            onClick={() => {
                setVerdict('rejected');
                setFieldValue('verdict', 'rejected');
                setStatus('');
            }}
        >
            <input
                id='kt_submit_review_type_rejected'
                type='radio'
                className='btn-check'
                name="verdict"
                value='rejected'
            />
            <label
                className={'btn py-2 px-6 d-flex flex-row align-items-center mb-2 ' + (verdict === 'rejected' ? 'btn-danger' : ' btn-outline btn-outline-dashed btn-outline-default')}
                htmlFor='kt_submit_review_type_rejected'
            >
                <KTSVG
                    path='/media/icons/duotune/abstract/abs012.svg'
                    className='svg-icon-2x me-5'
                />
                <div className='flex-grow-1 fw-bold text-center pe-10'>
                    <span className='fw-bolder d-block fs-4'>REJECT</span>
                </div>
            </label>
        </div>
    </div>
    </>
    )
}

export {VerdictSelector}